// Centralised countries dataset — single source of truth for country metadata.
// Add or remove countries here; the UI reads from this file automatically and
// no component needs to change.
//
// Schema:
//   slug         Stable URL-safe key (lowercased ISO)
//   name         Arabic display name (used in UI + filter URLs)
//   nameEn       English name (for backend / analytics / future locale)
//   isoCode      ISO 3166-1 alpha-2 (internal use only, not displayed)
//   displayOrder Optional secondary ordering key when counts tie
//                (lower number = earlier; leave for locale-alpha fallback if omitted)

export const COUNTRIES_DATASET = [
  { slug: "sa", name: "السعودية",  nameEn: "Saudi Arabia",         isoCode: "SA", displayOrder: 1 },
  { slug: "ae", name: "الإمارات",  nameEn: "United Arab Emirates", isoCode: "AE", displayOrder: 2 },
  { slug: "eg", name: "مصر",       nameEn: "Egypt",                isoCode: "EG", displayOrder: 3 },
  { slug: "jo", name: "الأردن",    nameEn: "Jordan",               isoCode: "JO", displayOrder: 4 },
  { slug: "ma", name: "المغرب",    nameEn: "Morocco",              isoCode: "MA", displayOrder: 5 },
  { slug: "qa", name: "قطر",       nameEn: "Qatar",                isoCode: "QA", displayOrder: 6 },
  { slug: "kw", name: "الكويت",    nameEn: "Kuwait",               isoCode: "KW", displayOrder: 7 },
  { slug: "om", name: "عُمان",     nameEn: "Oman",                 isoCode: "OM", displayOrder: 8 },
  { slug: "bh", name: "البحرين",   nameEn: "Bahrain",              isoCode: "BH", displayOrder: 9 },
  { slug: "tn", name: "تونس",      nameEn: "Tunisia",              isoCode: "TN", displayOrder: 10 },
  { slug: "dz", name: "الجزائر",   nameEn: "Algeria",              isoCode: "DZ", displayOrder: 11 },
  { slug: "sy", name: "سوريا",     nameEn: "Syria",                isoCode: "SY", displayOrder: 12 },
];

/** Legacy shape maintained for existing consumers (opportunities.js, tests). */
export const COUNTRIES = COUNTRIES_DATASET.map((c) => ({
  slug: c.slug,
  name: c.name,
  code: c.isoCode,
}));

/** Quick lookup helpers — useful when we swap to a backend without changing UI. */
export const getCountryBySlug = (slug) =>
  COUNTRIES_DATASET.find((c) => c.slug === slug) ?? null;

export const getCountryByName = (name) =>
  COUNTRIES_DATASET.find((c) => c.name === name || c.nameEn === name) ?? null;
